export default __webpack_public_path__ + "static/media/vkbg2.3a5fe3b9.jpg";